import { generatePath } from 'react-router-dom';
import { PARTNER_MANAGEMENT_PATH } from './paths';

// The partner page's route (ID-13792): one source of truth for the path, so the <Route> and every
// link to it share one string. Imported as `import * as partnerPageRoute` (the shared nav
// convention's `*.route.ts` shape); `path` is the react-router pattern, `getPath` builds a URL.
export const id = 'partnerPage';

/** The page's tabs, as their path segment; no segment, or an unknown one, lands on the first. */
export const TABS = ['details', 'permissions', 'entitlements', 'users', 'accounts', 'transactions'] as const;

export type PartnerPageTab = (typeof TABS)[number];

export const isTab = (value: string | undefined): value is PartnerPageTab => TABS.some((tab) => tab === value);

export const path = `${PARTNER_MANAGEMENT_PATH}/:partnerAccountID/:tab?`;

export function getPath({ partnerAccountID, tab }: { partnerAccountID: string; tab?: PartnerPageTab }) {
  return generatePath(path, { partnerAccountID, tab });
}
